export default "__VITE_ASSET__7cbc0372__"